import { color } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const baseStyles = [
  css`
    :where(.player-container) {
      display: block;
      inline-size: 100%;
    }
    :where(.placeholder-container) {
      position: relative;
    }
    :where(.placeholder-image) {
      inline-size: 100%;
    }
    :where(.placeholder-button) {
      align-items: center;
      background-color: ${color('grey', 800)};
      border: 0 none;
      color: ${color('white')};
      cursor: pointer;
      display: flex;
      justify-content: center;

      &:hover {
        background-color: ${color('grey', 700)};
      }
    }
  `,
];
